import type { Table } from 'dexie';

export const tableHasLibraryBookIndex = (table: Table) => {
  const { indexes } = table.schema;
  const lbIndex = indexes.find((index) => index.name === 'libraryBookId');
  return typeof lbIndex !== 'undefined';
};

export const tableHasSourceIndex = (table: Table) => {
  const { indexes } = table.schema;
  const lbIndex = indexes.find((index) => index.name === 'source');
  return typeof lbIndex !== 'undefined';
};

export const retrieveResultMapByProp = <T>(
  prop: string,
  results: T[]
): Map<string, T> => {
  const map = results.reduce((acc: Map<string, T>, cur: T) => {
    acc.set(cur[prop], cur);
    return acc;
  }, new Map<string, T>());
  return map;
};
